module.exports = __webpack_public_path__ + "assets/93f3fbf2f4173d33d0c219abe254aa91.png";